var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "logo_svg__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 400 400",
  style: {
    enableBackground: "new 0 0 400 400"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__st1,.logo_svg__st2,.logo_svg__st3{fill:#8c8c8c;stroke:#000;stroke-miterlimit:10}.logo_svg__st2,.logo_svg__st3{fill:#fff}.logo_svg__st3{fill:#bcbcbc}")), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#f69596",
    stroke: "#000",
    strokeMiterlimit: 10
  },
  d: "m86.5 332.5 17-9-2.4-86-14.6 23-7 20z"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st1",
  d: "m70.2 275 15.7 57.5h1l3.1-144-19.5 37z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "M35.5 231.5 35 37l82 48-4 28 14 79-40 67-19 16z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m95.5 104.5 64 13-4 91-6 21-13 31z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "M148.5 123.5v96h16l21-96z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m387.5 283.5-118-38-90 44 13 14z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#898989",
    stroke: "#000",
    strokeMiterlimit: 10
  },
  d: "m97.5 348.5 44-20-35.5-13.1z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#969696",
    stroke: "#000",
    strokeMiterlimit: 10
  },
  d: "m89.5 168-3 164.5 19-10v-157z"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m95.5 104.5 21-20 6.3 25.5z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m246.5 84.5-61 31-23 112 11 7 73-127z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m285.7 189.9-39.2 47.6-15-24zM309.3 236.1l-23.8 13.4-106 44 9-20z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m243.5 216.5 70 18-134 49 6-23z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m305.5 118.5-54 79-17-46z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m236.5 156.5 51 32-105 82-7-36z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m264.5 31.5-89 203 4 21 62-96 65-42z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#9b9b9b",
    stroke: "#000",
    strokeMiterlimit: 10
  },
  d: "m119.5 229.5 34.5-15.8 12.5 23.8-30 37z"
}), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st1",
  d: "m17.5 245.5 92-72-17-11z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st3",
  d: "m128.4 224.5 15.3-15H159l14.3 11 13.3 73-76.5 24 37.7-84c-.1 0 5-15-19.4-9z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m110.5 317.5 34 15 243-49-185 4zM117.5 166.5l19 92-39 88 6-183z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  className: "logo_svg__st2",
  d: "m87.5 155.5 30 11v2l-15 2-85 75zM159.5 118.4l-.2 5.1h-10.4c-.1 0-.1-.1 0-.2l9.9-5.4c.3-.1.7.1.7.5z"
})));
export default SvgLogo;